import { PageHero, SplitFeature, GallerySection, DarkCTA } from "@/components/Sections";
import { MovingChapters, MovingTypes, MovingExtras, MovingFaq } from "@/components/TraslochiSections";
import { MOVING_ITEMS, IMAGES } from "@/data/site";

export default function Traslochi() {
  return (
    <>
      <PageHero overline="Traslochi" title="Il trasloco, senza il peso del trasloco." img="/traslochi/carico.jpg"
        subtitle="Servizio completo con imballaggio, inscatolamento, smontaggio, facchinaggio, autoscala e rimontaggio. Operatori qualificati e mezzi propri." />
      <SplitFeature id="traslochi-detail" overline="Servizio completo"
        title="Ci occupiamo di tutto, dalla A alla Z."
        text="Programmiamo ogni fase del trasloco e coordiniamo il team di operatori per un servizio rapido, sicuro e senza stress."
        items={MOVING_ITEMS} img={IMAGES.traslochiRoom} cta="Organizza il tuo trasloco" ctaPreset={{ servizio: "trasloco" }} />
      <MovingChapters />
      <MovingTypes />
      <MovingExtras />
      <MovingFaq />
      <GallerySection />
      <DarkCTA />
    </>
  );
}
